const nodeEnv = process.env.NODE_ENV;
let deployEnv = nodeEnv === "production" ? "production" : "development";

const isClient = typeof window != "undefined" && window.document;
if (isClient) {
  if (window.location.hostname.includes("yocobeta.co.za")) {
    deployEnv = "staging";
  }
}

if (process.env.GATSBY_DEPLOY_ENV === "staging") {
  deployEnv = "staging";
}

const vwoEnabled = false;
const zendeskEnabled = true;
const fbEnabled = true;
const autoEnabled = true;

module.exports = {
  development: deployEnv === "development",
  signupURL: "https://signup.yoco.co.za/za/signup/v1/",
  firebaseReaderDataApiUrl:
    "https://yoco-storefront-prod.firebaseio.com/readerData/readOnly/readers.json",
  autoPilot: autoEnabled
    ? `(function(o){var b="https://api.autopilothq.com/anywhere/",t="d05c0950fc274b3aa2319be8249050cd102efbc4db784933a4cb8cb9d1a21ee4",a=window.AutopilotAnywhere={_runQueue:[],run:function(){this._runQueue.push(arguments);}},c=encodeURIComponent,s="SCRIPT",d=document,l=d.getElementsByTagName(s)[0],p="t="+c(d.title||"")+"&u="+c(d.location.href||"")+"&r="+c(d.referrer||""),j="text/javascript",z,y;if(!window.Autopilot) window.Autopilot=a;if(o.app) p="devmode=true&"+p;z=function(src,asy){var e=d.createElement(s);e.src=src;e.type=j;e.async=asy;l.parentNode.insertBefore(e,l);};y=function(){z(b+t+'?'+p,true);};if(window.attachEvent){window.attachEvent("onload",y);}else{window.addEventListener("load",y,false);}})({});`
    : "",
  facebook: fbEnabled
    ? `(function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v3.0&appId=105537239815279&autoLogAppEvents=1';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));`
    : "",
  // this is our code we use to setup vwo and as such enable AB testing across the site...
  vwoTrackingUrl: vwoEnabled
    ? `var _vwo_code=(function(){
        var account_id=198341,
        settings_tolerance=2000,
        library_tolerance=2500,
        use_existing_jquery=false,
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,d=document;return{use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){settings_timer=setTimeout('_vwo_code.finish()',settings_tolerance);var a=d.createElement('style'),b='body{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('//dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&r='+Math.random());return settings_timer;}};}());_vwo_settings_timer=_vwo_code.init();
        `
    : "",
  zendDesk: zendeskEnabled
    ? `window.zE || (function (e, t, s) {
  var n = window.zE = window.zEmbed = function () {
    n._.push(arguments)
  }, a = n.s = e.createElement(t), r = e.getElementsByTagName(t)[0];
  n.set = function (e) {
    n.set._.push(e)
  }, n._ = [], n.set._ = [], a.async = true, a.defer = true, a.setAttribute("charset", "utf-8"), a.src = "https://static.zdassets.com/ekr/asset_composer.js?key=" + s, n.t = +new Date, a.type = "text/javascript", r.parentNode.insertBefore(a, r)
})(document, "script", "3a295188-f310-4e9d-83c9-370abcd50ba6");

        zE(() => {
          $zopim(() => {
          $zopim.livechat.departments.setVisitorDepartment('Yoco Support');
          $zopim.livechat.departments.filter('Yoco Support', 'Yoco Sales');
          });
        });`
    : "",
  // used to talk to the backend
  apiURL:
    deployEnv === "production"
      ? "https://core.yoco.co.za"
      : deployEnv === "staging"
        ? "https://core.hippo.yocobeta.co.za"
        : "http://p.yoco.co.za:9090",
  // used to talk to the storefront when we need to, in future we phasing this out...
  signupApiURL:
    deployEnv === "production"
      ? "https://signup.yoco.co.za"
      : deployEnv === "staging"
        ? "https://signup.hippo.yocobeta.co.za"
        : "http://p.yoco.co.za:3000",
  nectarineUrl: {
    production: "https://nectarine.yoco.com/embed.min.js",
    staging: "https://nectarine.yoco.com/embed.min.js",
    development: "https://nectarine.yocobeta.co.za/embed.min.js"
  }[deployEnv],
  nectarinePublicKey: {
    production: "pk_live_e5f801f7m5WR5dm68254",
    staging: "pk_live_e5f801f7m5WR5dm68254",
    development: "pk_test_8f133808J4bGznOb4c45"
  }[deployEnv],
  segmentPublicKey: {
    production: "CNYnDQVnbLef8F4X5aQ8YqMishlB8MhH",
    staging: "BqBSFMu4BojjjdEuZ9BqhtRYoopFcQPA",
    development: "BqBSFMu4BojjjdEuZ9BqhtRYoopFcQPA"
  }[deployEnv],
  // used for post signup redirect to portal
  portalURL: {
    production: "https://portal.yoco.co.za",
    staging: "https://portal.yocobeta.co.za",
    development: "http://p.yoco.co.za:3000"
  }[deployEnv],
  signupVersion: "",

  // used to calculate card reader vat as we store numbers vat free
  vat: 1.15,
  piio: {
    production: {
      appKey: "epm4mq",
      domain: "https://www.yoco.co.za"
    },
    staging: {
      appKey: "mg59rg",
      domain: "https://www.hippo.yocobeta.co.za"
    },
    development: {
      development: true,
      appKey: "mg59rg",
      domain: "http://p.yoco.co.za:8000"
    }
  }[deployEnv]
};



// WEBPACK FOOTER //
// ./src/data/config.js